export default __webpack_public_path__ + "static/laptop-74d3e4b66a513d4abb199c2ef0cd3cf7.jpg";